"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const icons_1 = require("../../icons");
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const avatar_base_1 = __importStar(require("../avatar-base/avatar-base"));
function fontStyle(avatarSize, { size, typography }) {
    const style = {
        small: {
            fontSize: typography.small.fontSize,
        },
        medium: {
            fontSize: typography.body.fontSize,
        },
        large: {
            fontSize: size(20),
        },
    };
    return style[avatarSize];
}
const useStyles = (0, create_use_styles_1.default)(theme => {
    const { colors, typography } = theme;
    return {
        avatar: ({ error, name, variant }) => (error && !name) || !name
            ? {
                ...(0, avatar_base_1.colorStyle)(colors.darkgray, variant, theme),
            }
            : undefined,
        image: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "100%",
        },
        label: ({ size }) => (0, lodash_merge_1.default)({
            fontWeight: typography.fontWeights.semiBold,
            textAlign: "center",
            textTransform: "uppercase",
        }, fontStyle(size, theme)),
    };
});
function getInitials(name) {
    if (!name) {
        return "?";
    }
    const [firstName, lastName] = name.split(" ");
    if (firstName && lastName) {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    }
    else {
        return firstName.charAt(0);
    }
}
exports.Avatar = react_1.default.forwardRef(function Avatar({ className, color = "primary", name, size = "medium", src, srcSet, variant = "faded", ...props }, ref) {
    const [error, setError] = (0, react_1.useState)(false);
    const classes = useStyles({ error, name, size, variant });
    const img = src || srcSet;
    const initials = getInitials(name || "");
    const handleError = (0, react_1.useCallback)(() => {
        setError(true);
    }, []);
    return (react_1.default.createElement(avatar_base_1.default, { ref: ref, className: (0, classnames_1.default)(classes.avatar, className), color: color, size: size, variant: variant, ...props }, img && !error ? (react_1.default.createElement("img", { alt: name || "", className: classes.image, src: src, srcSet: srcSet, onError: handleError })) : name ? (react_1.default.createElement("div", { "aria-label": name, className: classes.label }, initials)) : (react_1.default.createElement(icons_1.UserIcon, null))));
});
exports.default = exports.Avatar;
//# sourceMappingURL=data:application/json;base64,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